import * as React from 'react';

function SvgCarretArrowDown(props) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.58702 12.1369C9.3714 11.9498 9.02773 11.9552 8.81942 12.1488C8.61112 12.3424 8.61705 12.651 8.83268 12.838L14.6257 17.8631C14.8361 18.0457 15.1698 18.0456 15.3802 17.863L21.1681 12.8379C21.3837 12.6507 21.3895 12.3422 21.1811 12.1486C20.9727 11.9551 20.629 11.9499 20.4135 12.137L15.0027 16.8347L9.58702 12.1369Z"
        fill={props?.fill || '#414B56'}
      ></path>
    </svg>
  );
}

export default SvgCarretArrowDown;
